var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "45px",
    viewBox: "0 0 12 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-150.000000, -209.000000)",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    transform: "translate(151.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.265012386,5.15017326 C0.224224823,5.15017326 0.183864355,5.15186517 0.143717434,5.15524899 L0.143717434,7.84961525 C0.14905612,7.84982674 0.154608354,7.85024972 0.15994704,7.85024972 L0.15994704,11.2031919 C0.288502605,12.2164343 1.16169813,13 2.2196122,13 L4.35999829,13 L4.35999829,5.15017326 L0.265012386,5.15017326 Z M5.6867686,5.15017326 L5.6867686,13 L7.82309729,13 C8.96771163,13 9.89578884,12.0810815 9.89578884,10.947502 L9.89578884,7.84052124 C9.89813787,7.84009826 9.90070044,7.83988677 9.90326301,7.83946379 L9.90326301,5.16201663 C9.84411036,5.15419154 9.78367643,5.15017326 9.72238831,5.15017326 L5.6867686,5.15017326 Z M0,2.44903935 C0,3.44197888 0.812975143,4.24669346 1.81515333,4.24669346 L1.81515333,4.24669346 L4.28824635,4.24669346 L4.28824635,4.24669346 L4.28824635,1.79744261 C4.28824635,0.804503083 3.47591185,0 2.47352012,0 L2.47352012,0 C1.10745708,0 0,1.096569 0,2.44903935 M5.71175365,1.79744261 L5.71175365,4.24648197 L5.71218075,4.24669346 L8.18527377,4.24669346 C9.1876655,4.24669346 10,3.44219037 10,2.44925084 L10,2.44925084 C10,1.096569 8.89275647,0 7.52690698,0 L7.52690698,0 C6.52494234,0 5.71175365,0.804503083 5.71175365,1.79744261",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftEmptyIcon);
export default __webpack_public_path__ + "static/media/gift-empty-icon.82b30394e9b570a7e8814e2c457dd131.svg";
export { ForwardRef as ReactComponent };